// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3QhpV","tab":"ProcedureTabs_tab__1e5fW"};